import { MessageBar, MessageBarType, Stack } from "@fluentui/react"
import { useState } from "react"

interface CardInfoProps {
	controlType: "WebResource" | "Portal"
}

export function CardInfo({ controlType }: CardInfoProps) {
	const queryParameters = new URLSearchParams(window.location.search)
	const data = queryParameters.get("data")
	const dataUnencoded = atob(data)

	const [error, _setError] = useState<string>()

	return (
		<>
			<Stack tokens={{ childrenGap: 10 }} style={{ padding: 15 }}>
				{error && <MessageBar messageBarType={MessageBarType.error}>{error}</MessageBar>}

				{data && dataUnencoded && (
					<div style={{ border: "1px solid #ccc", padding: 10, maxWidth: 400 }}>
						<Stack tokens={{ childrenGap: 10 }}>
							<span dangerouslySetInnerHTML={{ __html: dataUnencoded.replace(/\r\n/g, "<br/>").replaceAll("\b", "<b>").replaceAll("/b", "</b>") }} />
						</Stack>
					</div>
				)}
			</Stack>
		</>
	)
}
